import { clamp } from '../utils/clamp';
import { timing } from '../metrics/timing';
const MIN_PERIOD = 15000; // 15s
const MAX_PERIOD = 300000; // 5min
const SWEEP_INTERVAL = 30000; // 30s

const MIN_RETAIN_PERIOD = 15000; // 15s
const MAX_RETAIN_PERIOD = 1800000; // 30min

let __TEST_ONLY_DISABLE_CACHE_GC = false;
export const __testOnlyDisableCacheGC = () => {
  __TEST_ONLY_DISABLE_CACHE_GC = true;
};
export const __testOnlyEnableCacheGC = () => {
  __TEST_ONLY_DISABLE_CACHE_GC = false;
};
export const createGCManager = ({
  nodes,
  removeNode,
  logger
}) => {
  const candidates = new Set();
  let sweepTimer = null;
  const sweep = () => {
    const now = Date.now();
    for (const instanceKey of candidates) {
      var _entry$lifecycle$vali;
      const entry = nodes.get(instanceKey);
      if (entry && ((_entry$lifecycle$vali = entry.lifecycle.validUntil) !== null && _entry$lifecycle$vali !== void 0 ? _entry$lifecycle$vali : 0) > now) {
        continue;
      }
      candidates.delete(instanceKey);
      if (!entry || entry.lifecycle.attachedSince != null) {
        continue;
      }
      timing.timeCollectNode(() => {
        logger === null || logger === void 0 || logger.debug('collecting node', {
          instanceKey
        });
        removeNode(instanceKey);
      });
    }
    if (candidates.size === 0 && sweepTimer !== null) {
      clearInterval(sweepTimer);
      sweepTimer = null;
    }
  };
  const ensureSweeping = () => {
    if (sweepTimer === null) {
      sweepTimer = setInterval(sweep, SWEEP_INTERVAL);
    }
  };
  const extend = (instanceKey, validUntil) => {
    var _entry$lifecycle$vali2;
    const entry = nodes.get(instanceKey);
    if (!entry) {
      return;
    }
    if (validUntil > ((_entry$lifecycle$vali2 = entry.lifecycle.validUntil) !== null && _entry$lifecycle$vali2 !== void 0 ? _entry$lifecycle$vali2 : 0)) {
      entry.lifecycle.validUntil = validUntil;
    }
    if (__TEST_ONLY_DISABLE_CACHE_GC || entry.lifecycle.attachedSince != null || candidates.has(instanceKey)) {
      return;
    }
    entry.lifecycle.queuedAt = Date.now();
    candidates.add(instanceKey);
    ensureSweeping();
  };
  return {
    queue: (instanceKey, period) => {
      extend(instanceKey, Date.now() + clamp(period, MIN_PERIOD, MAX_PERIOD));
    },
    retain: (instanceKey, period = MAX_RETAIN_PERIOD) => {
      extend(instanceKey, Date.now() + clamp(period, MIN_RETAIN_PERIOD, MAX_RETAIN_PERIOD));
    },
    getAllStatuses: () => {
      const result = {};
      for (const instanceKey of candidates) {
        var _nodes$get;
        const {
          lifecycle
        } = (_nodes$get = nodes.get(instanceKey)) !== null && _nodes$get !== void 0 ? _nodes$get : {};
        if ((lifecycle === null || lifecycle === void 0 ? void 0 : lifecycle.validUntil) != null && lifecycle.queuedAt != null && lifecycle.attachedSince == null) {
          result[instanceKey] = {
            scheduledAt: lifecycle.queuedAt,
            executeAt: lifecycle.validUntil
          };
        }
      }
      return result;
    }
  };
};